export const experiences = {
  ONBOARD: 'onboard',
  CORE: 'core',
  LOADING: 'loading',
  LINK_ONBOARD: 'linkOnboard',
};
